module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.94/js/sprocket_white.svg"